import { Grid } from '@material-ui/core';
import dayjs from 'dayjs';
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { loadExteriorImg } from '../../../../../redux/agreement/actions';
import { closeModal, openModal } from '../../../../../redux/modals/action';
import CustomButton from '../../../../layout/customButton/CustomButton';
import FloorplanModal from './FloorplanModal/FloorplanModal';
import styles from './ProductInformation.module.scss';
import _ from 'lodash';

const ProductInformation = ({
	modelName,
	lotNumber,
	lotSizeType,
	lotSize,
	elevation,
	options,
	closingDate,
	loadExteriorImg,
	exteriorImage,
	openModal,
	closeModal,
	showFloorplanModal,
	printMode,
	offerDate,
}) => {
	useEffect(() => {
		if (exteriorImage.length === 0 && modelName && elevation) {
			loadExteriorImg(modelName, elevation?.toLowerCase());
		}

		console.log('exteriorImage', exteriorImage);
	}, []);

	const handleOpenFloorPlans = () => {
		var count = 0;
		console.log('handleOpenFloorPlans I am being ran ', count++);
		openModal('reviewFloorplans');
	};

	useEffect(() => {
		console.log('showFloorplanModal', showFloorplanModal);
	}, [showFloorplanModal]);

	return (
		<div className={styles.product_info_wrapper}>
			<Grid container className={styles.models_lots_details}>
				<Grid item xs={2} className={styles.title}>
					Models &amp; Lots
				</Grid>
				<Grid item xs={10} className={styles.content} container>
					{!printMode && (
						<div className={styles.image__btn_wrapper}>
							<div className={styles.exterior_image}>
								<img
									src={
										exteriorImage[0] ||
										'https://firebasestorage.googleapis.com/v0/b/planxr-demo-centre.appspot.com/o/clean_tech_commons%2FbuildingExteriors%2F70-01%2Fa%2Fplaceholder-company.png?alt=media&token=46c47eda-c1bd-4c44-83b5-68e342e4e1fd'
									}
									alt='Model Image'
								/>
							</div>

							<div className={styles.btn_group}>
								<div className={styles.btn_item}>
									<CustomButton
										outlined
										width={166}
										onClick={handleOpenFloorPlans}
									>
										Floor Plans
									</CustomButton>
								</div>
								{/* <div className={styles.btn_item}>
									<CustomButton outlined width={166}>
										Option Plans
									</CustomButton>
								</div> */}
							</div>
						</div>
					)}
					{/* These are the text ont he right of the image */}
					<div className={styles.model_text}>
						<div className={styles.model_name}>{modelName}</div>
						<div className={styles.frontage_size}>
							{lotSizeType}" Lot
						</div>

						<div className={styles.main_texts}>
							<div className={styles.lot_num}>
								Lot {lotNumber}
							</div>
							<div className={styles.lot_num}>{lotSize} Sqft</div>
							{/* <div className={styles.lot_num}>4 Bedrooms</div> */}
							<div className={styles.lot_num}>
								Elevation {elevation}
							</div>
						</div>
						<div className={styles.options}>
							<div className={styles.option_title}>
								Options selected
							</div>
							{_.keys(options)?.length > 0 ? (
								<div className={styles.option_items}>
									{_.toArray(options)?.map(
										(option, index) => (
											<div
												className={styles.option_item}
												key={index}
											>
												{option.name}
											</div>
										)
									)}
								</div>
							) : (
								<div className={styles.option_item}>-</div>
							)}
						</div>
					</div>
				</Grid>
			</Grid>
			<Grid container className={styles.models_lots_details}>
				<Grid item xs={2} className={styles.title}>
					Critical Dates
				</Grid>
				<Grid item xs={10} className={styles.content}>
					<div className={styles.dates_wrapper}>
						<div className={styles.date_item}>
							<div className={styles.item_title}>Offer date</div>
							<div className={styles.item_result}>
								{dayjs(offerDate).format('MMM DD, YYYY')}
							</div>
						</div>
						<hr className={styles.separator} />
						<div className={styles.date_item}>
							<div className={styles.item_title}>
								Closing date
							</div>
							<div className={styles.item_result}>
								{dayjs(closingDate).format('MMM DD, YYYY')}
							</div>
						</div>
					</div>
				</Grid>
			</Grid>
		</div>
	);
};

const mapStateToProps = (state) => ({
	modelName:
		state.agreement?.productAvailability?.modelName ||
		state.agreement?.agreementById?.productAvailability?.modelName,
	lotNumber:
		state.agreement?.productAvailability?.lotId ||
		state.agreement?.agreementById?.productAvailability?.lotId,
	lotSizeType:
		state.agreement?.productAvailability?.lotSizeType ||
		state.agreement?.agreementById?.productAvailability?.lotSizeType,
	lotSize:
		state.agreement?.productAvailability?.lotSize ||
		state.agreement?.agreementById?.productAvailability?.lotSize,
	elevation:
		state.agreement?.productAvailability?.elevation?.id ||
		state.agreement?.agreementById?.productAvailability?.elevation?.id,
	options: state.agreement?.agreementById?.options,
	closingDate:
		state.agreement?.productAvailability?.closingDate ||
		state.agreement?.agreementById?.productAvailability?.closingDate,
	exteriorImage: state.agreement.exteriorImage,
	showFloorplanModal: state.modals?.reviewFloorplans,
	offerDate: state.agreement?.agreementById?.leadDetails?.createTimeStamp,
});

export default connect(mapStateToProps, {
	loadExteriorImg,
	openModal,
	closeModal,
})(ProductInformation);
